import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { ToasterService } from '../../services/toaster.service';
import { navigateBasedOnPermissions } from '../helpers/navigateBasedOnPermissions';

export const AuthGuardFxn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const _authService = inject(AuthService);
  const router = inject(Router);
  const _toasterService = inject(ToasterService);
  const _translateService = inject(TranslateService);

  // multitenant to single tenant
  // multitenant to singletenant
  // const subscriptionStatusConst = [2, 4, 5];
  // const subscriptionStatus = Number(localStorage['subscriptionStatus']);

  // --- Allow login route handling ---
  if (state.url.includes('/auth/login')) {
    if (_authService.isAuthenticated()) {
      const profile = await _authService.ensureProfileLoaded();
      const permissions = profile?.accessRole?.permissions || [];
      navigateBasedOnPermissions(permissions, router, profile);
      return false;
    }
    return true;
  }

  // --- Block unauthenticated users ---
  if (!_authService.isAuthenticated()) {
    _toasterService.errToastr(_translateService.instant('LoginFirst'));
    return router.parseUrl('/auth/login');
  }

  // multitenant to single tenant
  // multitenant to singletenant
  // --- Restrict based on subscription (multi-tenant / expired plan flows) ---
  // if (subscriptionStatusConst.includes(subscriptionStatus)) {
  //   const allowedUrl = '/manage-settings';
  //   const allowedTab = '2';
  //
  //   const isOnAllowedRoute =
  //     state.url.startsWith(allowedUrl) &&
  //     route.queryParams['tabIndex'] === allowedTab;
  //
  //   if (!isOnAllowedRoute) {
  //     _toasterService.errToastr(
  //       _translateService.instant('PleaseUpdateSubscription')
  //     );
  //     return router.createUrlTree([allowedUrl], {
  //       queryParams: { tabIndex: allowedTab }
  //     });
  //   }
  // }

  return true;
};

